import styled from 'styled-components';
import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';
import { WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR } from '../../constants/constants';

export const HeroContainer = styled.div`
  background: var(--color-dark);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  min-height: 700px;
  width: 100%;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 1000px;
  position: absolute;
  padding: 8px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HeroH1 = styled.h1`
  color: var(--color-cream);
  font-family: var(--font-heading);
  font-size: 68px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1px;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.6);

  span {
    color: var(--color-gold-light);
  }

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    font-size: 48px;
  }

  @media screen and (max-width: 480px) {
    font-size: 36px;
  }
`;

export const HeroP = styled.p`
  margin-top: 20px;
  color: var(--color-tan);
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 4px;
  text-transform: uppercase;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);

  @media screen and (max-width: ${WINDOW_WIDTH_CHANGE_TO_MOBILE_NAVBAR}px) {
    font-size: 16px;
  }

  @media screen and (max-width: 480px) {
    font-size: 13px;
    letter-spacing: 2px;
  }
`;

export const HeroRule = styled.hr`
  width: 60px;
  border: none;
  border-top: 2px solid var(--color-gold);
  margin: 24px auto;
`;

export const HeroBtnWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: 18px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: 18px;
`;